// Delivery estimate: recalculates dispatch and delivery dates from the shopper's current day (India time),
// so cached pages never show stale dates. Liquid renders a server-side fallback first.
class SDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const dispatchDays = Number(this.dataset.dispatchDays) || 0;
    const deliveryDays = Number(this.dataset.deliveryDays) || 0;
    const format = new Intl.DateTimeFormat(this.dataset.locale || 'en-IN', {
      day: 'numeric',
      month: 'short',
      timeZone: this.dataset.timeZone || 'Asia/Kolkata',
    });
    const today = new Date();
    const addDays = (days) => new Date(today.getTime() + days * 86400000);

    this.querySelectorAll('[data-date-offset]').forEach((node) => {
      const key = node.dataset.dateOffset;
      const days = key === 'dispatch' ? dispatchDays : key === 'delivery' ? deliveryDays : 0;
      node.textContent = format.format(addDays(days));
    });
  }
}

if (!customElements.get('s-delivery-estimate')) customElements.define('s-delivery-estimate', SDeliveryEstimate);
